import isEmpty from 'lodash/isEmpty';
import { useCMSPage } from '@belong/contentful';
import { FORM_ROOT, FormLogin, useViewModel } from '@belong/journey-authentication';
import { ILoginFormContent } from '@belong/journey-authentication/components/FormLogin/types';
import { IBasePageProps, OUTER_SPACING } from '@belong/types';
import { ErrorPage, Section, Skeleton } from '@belong/ui-components';
import { Layout } from '@belong/ui-components/components/layout/FormCard';
import { routes } from 'src/helpers/constants/routes';
import { SECTION_TEST_ID } from 'src/helpers/constants/testIds';
import { useUserContext } from 'src/helpers/context/UserContext';
import type { NextPage } from 'next';

export const LoginPage: NextPage<IBasePageProps> = () => {
  const { login: userLogin, updateUserDetails, isBusy } = useUserContext();
  const { data: { content } = {}, error } = useCMSPage<ILoginFormContent>();
  const { isRedirectingToMfa, destinationOverrideUrl, initialAlertReason, headingVariant, handleLoginSubmit } =
    useViewModel(userLogin, updateUserDetails, routes);

  if (isRedirectingToMfa) {
    return <Skeleton />;
  }

  if (error) {
    return <ErrorPage statusCode={500} />;
  }

  return (
    <Section
      hasPaddingTop
      hasPaddingBottom
      paddingSize={OUTER_SPACING.LOOSE}
      data-testid={SECTION_TEST_ID.LOGIN}
      hasBackground="grey"
      containsCard
    >
      <Layout cardProps={{ 'data-testid': FORM_ROOT, hasSectionPaddingTop: true }}>
        {isEmpty(content) ? (
          <Skeleton />
        ) : (
          <FormLogin
            isStoreBusy={isBusy}
            onLoginSubmit={handleLoginSubmit}
            destinationOverrideUrl={destinationOverrideUrl}
            initialAlertReason={initialAlertReason}
            headingVariant={headingVariant}
            content={content}
          />
        )}
      </Layout>
    </Section>
  );
};

export default LoginPage;
